import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { adminLogin, setToken } from "../lib/api";
import { COMPANY } from "../data/site";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await adminLogin(email, password);
      setToken(data.access_token);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A221C] px-6 relative overflow-hidden">
      <div className="grain" />
      <div className="relative w-full max-w-md bg-white rounded-3xl p-8 md:p-10 shadow-2xl">
        <span className="inline-block bg-white rounded-xl mb-6">
          <img src={COMPANY.logo} alt="Life Line" className="h-12 w-auto object-contain" />
        </span>
        <h1 className="font-display text-3xl font-bold text-[#0A221C]">Admin Login</h1>
        <p className="text-[#4A5D58] mt-1">Manage your enquiry leads.</p>

        <form onSubmit={submit} className="mt-8 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="eyebrow text-[#4A5D58] block mb-2">Email</label>
            <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="ll-input" placeholder="admin@lifelinetravels.in" />
          </div>
          <div>
            <label className="eyebrow text-[#4A5D58] block mb-2">Password</label>
            <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="ll-input" placeholder="••••••••" />
          </div>
          <button data-testid="admin-login-submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={18} /> : <Lock size={18} />}
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
